import { API_BASE_URL } from '../api';
import { postGenerationJob } from './generationJob.api';

/**
 * Perform virtual try-on using the VirtualTryonV2 endpoint
 * @param {string} productCategory - The category of the product (e.g., 'women-clothing', 'men-clothing')
 * @param {string} productType - The type of the product (e.g., 'saree', 'lehenga', 'dress')
 * @param {string} productImage - URL of the product image
 * @param {string} userImage - URL of the user's image for virtual try-on
 * @param {Object} linkOptions - Optional link + customization payload
 * @returns {Promise<Object>} - Response object with success status and generated image data
 */
export const performVirtualTryOnV2 = async (
  productCategory,
  productType,
  productImage,
  userImage,
  linkOptions = {}
) => {
  const payload = {
    productCategory,
    productType,
    productImage,
    userImage,
    ...(linkOptions.sourceInspirationalDesignId && {
      sourceInspirationalDesignId: String(linkOptions.sourceInspirationalDesignId)
    }),
    ...(linkOptions.inspirationalDesignImage && {
      inspirationalDesignImage: linkOptions.inspirationalDesignImage
    }),
    ...(linkOptions.garmentInspirationImage && {
      garmentInspirationImage: linkOptions.garmentInspirationImage
    }),
    ...(linkOptions.productTypeCustomizations && {
      productTypeCustomizations: linkOptions.productTypeCustomizations
    }),
    ...(linkOptions.productTypeCustomizationReferences && {
      productTypeCustomizationReferences: linkOptions.productTypeCustomizationReferences
    })
  };

  console.log("VirtualTryonV2 API payload:", JSON.stringify(payload, null, 2));

  try {
    return postGenerationJob(`${API_BASE_URL}/virtual-tryon/v2`, payload, {
      maxWaitMs: 8 * 60 * 1000,
    });
  } catch (error) {
    console.error('VirtualTryonV2 API error:', error);
    
    // Handle timeout errors specifically
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timed out after 3 minutes. Please try again.');
    }
    
    alert(error);
    throw error;
  }
};
